<app-content-auth>
	<ng-container>
		<div class="right_login">
			<div class="content_form">
				<div class="tab-slider--container">
					<app-login-form [user]="user" [codeLogin]="codeUserRemenber"></app-login-form>
				</div>
			</div>
		</div>
	</ng-container>
</app-content-auth>
